import React from 'react';
import Modal from './Modal';
import Text from '../Text';

/**
 * 
 * @returns 
 */
const SendPasswordResetModal = ({
  open,
  close,
  resetPassword,
  loader
}) => /*#__PURE__*/React.createElement(Modal, {
  open: open,
  onClose: close,
  title: "Reset Password",
  primaryButton: {
    label: "Continue",
    onClick: resetPassword
  },
  loader: loader
}, /*#__PURE__*/React.createElement(Text, {
  medium: true,
  light: true
}, "You are about to send an email with a temporary password, are you sure you want to continue? This cannot be undone."));
export default SendPasswordResetModal;